import React from 'react';
import styles from './legalSms.scss';

export const LegalSms: React.FC = () => {
  return (
    <div className={styles.legalCopyContainer}>
      Note: You may only send SMS messages to guests who have agreed to receive updates from you. Available for U.S.
      phone numbers only.
    </div>
  );
};
